import local from "../continue/local";
export default class index {
    constructor() {
        this.localSta = new local();
    }
    base = ()=>{
        return JSON.parse(this.localSta.get('webSite'))
    }

    token = () => {
        return this.localSta.get('token');
    }

    time = () => {
        return this.localSta.get('time');
    }

    uid = () => {
        return JSON.parse(this.localSta.get('userInfo'))['id']
    }

    userInfo = () => {
        return this.localSta.get('userInfo');
    }


}


// WEBPACK FOOTER //
// ./src/controller/public/index.js